import React, { FunctionComponent } from 'react';

import { MortgageProviderStep as CommonMortgageProviderStep } from 'scenes/common/components/Steps';
import { InsuredItem } from 'scenes/common/types';
import { getApiData } from 'scenes/common/helpers/apiData';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import {
  getMortgageProvider,
  getMortgageProviderOther,
} from 'scenes/landlord/selectors';

export const MortgageProviderStep: FunctionComponent<LandlordFullPageProps> = ({
  onUpdateToPolicyDetails,
  funnelState,
  referenceData,
}) => {
  const { mortgageProviderOptions } = getApiData(referenceData);
  return (
    <CommonMortgageProviderStep
      onNext={onUpdateToPolicyDetails}
      defaultStateValue={getMortgageProvider(funnelState)}
      options={mortgageProviderOptions}
      mortgageProviderOtherDefaultValue={getMortgageProviderOther(funnelState)}
      insuredItem={InsuredItem.Property}
    />
  );
};

export default MortgageProviderStep;
